var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C8.89543 2 8 2.89543 8 4V6H5H3.92602H3V8H4.06888L4.86986 19.2137C4.982 20.7837 6.28832 22 7.86224 22H16.1378C17.7117 22 19.018 20.7837 19.1301 19.2137L19.9311 8H21V6H20.074H19H16V4C16 2.89543 15.1046 2 14 2H10ZM14 6V4H10V6H14ZM6.07398 8H17.926L17.1352 19.0712C17.0978 19.5946 16.6624 20 16.1378 20H7.86224C7.3376 20 6.90216 19.5946 6.86478 19.0712L6.07398 8ZM13 18V10H15V18H13ZM9 10V18H11V10H9Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.3ab055ef01b46f9f4d280c599f1b0765.svg";
export { ForwardRef as ReactComponent };